var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn bg-success",attrs:{"type":"button","onclick":_vm.onclick,"name":_vm.name,"id":_vm.id,"data-popup":"tooltip","title":_vm.alt,"data-placement":_vm.altplacement}},[_vm._v("\n  "+_vm._s(_vm.value)+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610930ff","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-components/buttons/ok-button.vue
// module id = 1590
// module chunks = 0